import { ColorVariant } from '@makyoapp/makyo-tw-ui'

export interface CompHiddenFieldProps {
  isPreview: boolean
  columnName?: string
  currentValue: React.ReactNode
  style: React.CSSProperties
  backgroundColor?: ColorVariant
}

/**
 * CompHiddenFieldCore
 */
export const CompHiddenFieldCore = ({
  isPreview,
  style,
  backgroundColor,
  currentValue,
  columnName,
}: CompHiddenFieldProps) => {
  return isPreview ? (
    <div className={`p-4 border-2 border-on-${backgroundColor}/30 border-dashed`} style={{ ...style }}>
      <span className={`text-on-${backgroundColor}/70`}>
        {columnName ? (
          <span>
            Hidden Field ({columnName}){currentValue}
          </span>
        ) : (
          <span>
            Hidden Field: No column selected
          </span>
        )}
      </span>
    </div>
  ) : null
}
